import styled from 'styled-components'

interface RadioContainerProps {
  checked: boolean;
  variant: 'default' | 'outlined',
  isIncorrect?: boolean;
}

export const RadioContainer = styled.div<RadioContainerProps>`
  width: ${props => props.variant === 'default' ? 'fit-content' : '100%'};
  border: ${({ checked, variant, isIncorrect }) => variant === 'default' ? 
    'none' : 
    isIncorrect ? '2px solid #E84242' : 
    checked ? '4px solid #3D6666' : '2px solid #C8C8C8'
  };
  background: ${({ checked, variant }) => variant === 'default' ? 'inherit' : checked ? '#F5F9F9' : '#FFF'};
  display: flex;
  align-items: center;
  cursor: pointer;

  & input {
    display: none;
  }

  & span {
    font-weight: ${props => props.variant === 'default' ? 400 : 900};
    font-size: 16px;
    line-height: 24px;
  }

  & .ball {
    border: ${props => props.checked ? '7px solid #3D6666' : '2px solid #C8C8C8'};
    border-radius: 50%;
    background: #fff;
    height: 24px;
    width: 24px;
    margin: ${props => props.variant === 'default' ? '0 14px 0 0' : '16px 16px 16px 24px'};
  }
`